import React from 'react';

import { IconButton, Tooltip, TooltipProps, alpha, styled, tooltipClasses } from '@mui/material';

export const ToolTip = styled(
	// @TODO: Check it
	({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />,
)(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		padding: '4px 8px',
		borderRadius: '4px',
		background: '#fff',
		color: theme.palette.text.secondary,
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: '#fff',
	},
}));

export const TabsWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	justifyContent: 'space-between',
	flexWrap: 'wrap',

	[theme.breakpoints.down('md')]: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		'& > *': {
			width: '100%',
		},
	},
}));

export const TabsScrollerWrap = styled('div')(({ theme }) => ({
	position: 'relative',
	flex: 1,
	minWidth: 0,

	[theme.breakpoints.down('md')]: {
		width: '100%',
	},
}));

export const ScrollFade = styled('div', {
	shouldForwardProp: (prop) => prop !== 'direction',
})<{ direction: 'left' | 'right' }>(({ theme, direction }) => ({
	position: 'absolute',
	top: 0,
	bottom: 0,
	width: '70px',
	zIndex: 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: direction === 'left' ? 'flex-start' : 'flex-end',
	pointerEvents: 'none',
	borderRadius: '20px 20px 0 0',
	...(direction === 'left'
		? {
				left: 0,
				background: `linear-gradient(90deg, ${theme.palette.background.paper} 30%, ${alpha(theme.palette.background.paper, 0)} 100%)`,
			}
		: {
				right: 0,
				background: `linear-gradient(270deg, ${theme.palette.background.paper} 30%, ${alpha(theme.palette.background.paper, 0)} 100%)`,
			}),
}));

export const ScrollArrowButton = styled(IconButton)(({ theme }) => ({
	pointerEvents: 'auto',
	margin: theme.spacing(0, 0.5),
	background: theme.palette.background.paper,
	boxShadow: theme.shadows[1],
	'&:hover': {
		background: theme.palette.background.paper,
	},
}));
